import apiUrl from '../../../../constants';
import axios from 'axios'
import common_helper from '../../../../common_helper';
import CryptoJS from 'crypto-js'


export default {
	name: 'slaglobal',
	components: {
	},
	mounted(){
		this.getOutboundConfigGlobal();
		this.getInboundConfigGlobal();
		this.getReturnsConfigGlobal();
	},
	data() {
		return {
			accordianTab: {
				4: false,
				5: false,
				6: false,
			},
			isLoading: false,

			inboundConfigId:'',
			outboundConfigId:'',
			returnb2cConfigId:'',
			returnb2bConfigId:'',

			inboundtathrs: 0,
			inboundtatmin: 0,
			inboundthresholdhrs: 0,
			inboundthresholdmin: 0,
			inboundthresholdErr: '',
			outboundTatType: 'fixedDuration',
			inboundTatType:'fixedDuration',
			returnsTatType:'fixedDuration',
			outboundTatTypeRadioButton: 'fixedDuration',
			inboundTatTypeRadioButton: 'cutoff',
			returnsTatTypeRadioButton: 'fixedDuration',
			btocReturns : {
				hrs: null,
				min: null,
				hrminErr: ''
			},
			btocReturnsThreshold: {
				hrs: null,
				min: null
			},
			btobReturns : {
				hrs: null,
				min: null
			},
			btobReturnsThreshold: {
				hrs: null,
				min: null
			},
			outboundFixedDuration: {
				hrs: null,
				min: null,
			},
			outboundFixedDurationThreshold: {
				hrs: null,
				min: null,
				hrMinErr: ''
			},
			orderCreationCutoff:{
				day: 1,
				hrs: null,
				min: null,
			},
			drCreationCutoff:{
				day: 1,
				hrs: null,
				min: null,
			},
			inboundSla:{
				day: null,
				hrs: null,
				min: null,
				err: ''
			},
			inboundThreshold:{
				hrs: null,
				min: null,
				err: ''
			},
			returnsb2cCreationCutoff:{
				day: 1,
				hrs: null,
				min: null,
			},
			returnsb2cSla:{
				day: null,
				hrs: null,
				min: null,
				err: ''
			},
			returnsb2cThreshold:{
				hrs: null,
				min: null,
				err: ''
			},
			returnsb2bCreationCutoff:{
				day: 1,
				hrs: null,
				min: null,
			},
			returnsb2bSla:{
				day: null,
				hrs: null,
				min: null,
				err: ''
			},
			returnsb2bThreshold:{
				hrs: null,
				min: null,
				err: ''
			},
			outboundSla:{
				day: null,
				hrs: null,
				min: null,
				err: ''
			},
			outboundThreshold:{
				hrs: null,
				min: null,
				err: ''
			},
		}
	},
	computed: {},
	filters: {

	},

	methods: {
		toggleCheck(tabid) {
			for (var key in this.accordianTab) {
				if (tabid != key) {
					this.accordianTab[key] = false;
				}
			}
		},
		async getInboundConfigGlobal(){
			const userToken = window.localStorage.getItem('userToken');
			const myStr = userToken.replace(/"/g, '');
			const input = ({
				slalevel: 'global',
				module: 'inbound',
			});
			const result = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(result.status == 200 && result.data.data.length > 0){
				const inboundConfig = result.data.data[0];
				this.inboundConfigId = inboundConfig.id;
				if(inboundConfig.tattype === 'cutoff'){
					this.drCreationCutoff.day = inboundConfig.tattime && inboundConfig.tattime.days ? inboundConfig.tattime.days : 1;
					this.drCreationCutoff.hrs =  inboundConfig.tattime && inboundConfig.tattime.hours ? inboundConfig.tattime.hours : 0;
					if(this.drCreationCutoff.day>7){this.drCreationCutoff.day = 1;}
					this.drCreationCutoff.min = inboundConfig.tattime && inboundConfig.tattime.minutes || 0;
					this.inboundSla.day = inboundConfig.outboundsla && inboundConfig.outboundsla.days ? inboundConfig.outboundsla.days : 0;
					this.inboundSla.hrs = inboundConfig.outboundsla && inboundConfig.outboundsla.hours ? inboundConfig.outboundsla.hours: 0;
					this.inboundSla.min = inboundConfig.outboundsla && inboundConfig.outboundsla.minutes || 0;
					this.inboundThreshold.hrs = inboundConfig.nearbreach && inboundConfig.nearbreach.hours || 0;
					this.inboundThreshold.min = inboundConfig.nearbreach && inboundConfig.nearbreach.minutes || 0;
					this.inboundTatType='cutoff';
					this.inboundTatTypeRadioButton = this.inboundTatType;
					this.inboundthresholdErr='';
				}
				else{
				this.inboundtathrs = inboundConfig.tattime.hours || 0;
				this.inboundtatmin =  inboundConfig.tattime.minutes || 0;
				this.inboundthresholdhrs = inboundConfig.nearbreach.hours || 0;
				this.inboundthresholdmin = inboundConfig.nearbreach.minutes || 0;
				this.inboundTatType='fixedDuration';
				this.inboundTatTypeRadioButton = this.inboundTatType;
				}
			}
		},
		async transitFixedDurAndCutoffBased(){
			this.orderCreationCutoff.day = 1;
			this.orderCreationCutoff.hrs =  null;
			this.orderCreationCutoff.min = null;
			this.drCreationCutoff.day = 1;
			this.drCreationCutoff.hrs =  null;
			this.drCreationCutoff.min = null;
			this.outboundSla.day = null;
			this.outboundSla.hrs = null;
			this.outboundSla.min = null;
			this.inboundSla.day = null;
			this.inboundSla.hrs = null;
			this.inboundSla.min = null;
			this.inboundThreshold.hrs = null;
			this.inboundThreshold.min = null;
			this.outboundThreshold.hrs = null;
			this.outboundThreshold.min = null;
			this.outboundFixedDuration.hrs = null;
			this.outboundFixedDuration.min =  null;
			this.outboundFixedDurationThreshold.hrs = null;
			this.outboundFixedDurationThreshold.min = null;
			this.inboundtathrs=null
			this.inboundtatmin=null
			this.inboundthresholdhrs=null
			this.inboundthresholdmin=null
			await this.getOutboundConfigGlobal();
			await this.getInboundConfigGlobal();
			await this.getReturnsConfigGlobal();
			this.outboundTatTypeRadioButton = 'cutoff'
			this.inboundTatTypeRadioButton= 'cutoff'
			this.returnsTatTypeRadioButton = 'cutoff'
			
		},
		async getOutboundConfigGlobal(){
			const userToken = window.localStorage.getItem('userToken');
			const myStr = userToken.replace(/"/g, '');
			const input = ({
				slalevel: 'global',
				module: 'outbound',
			});
			const result = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(result.status == 200 && result.data.data.length > 0){
				const outboundConfig = result.data.data[0];
				this.outboundConfigId = outboundConfig.id;
				if(outboundConfig.tattype === 'cutoff'){

					this.orderCreationCutoff.day = outboundConfig.tattime && outboundConfig.tattime.days ? outboundConfig.tattime.days : 1;
					this.orderCreationCutoff.hrs =  outboundConfig.tattime && outboundConfig.tattime.hours ? outboundConfig.tattime.hours : 0;
					if(this.orderCreationCutoff.day>7){this.orderCreationCutoff.day = 1;}
					this.orderCreationCutoff.min = outboundConfig.tattime && outboundConfig.tattime.minutes || 0;
					this.outboundSla.day = outboundConfig.outboundsla && outboundConfig.outboundsla.days ? outboundConfig.outboundsla.days : 0;
					this.outboundSla.hrs = outboundConfig.outboundsla && outboundConfig.outboundsla.hours ? outboundConfig.outboundsla.hours: 0;
					this.outboundSla.min = outboundConfig.outboundsla && outboundConfig.outboundsla.minutes || 0;
					this.outboundThreshold.hrs = outboundConfig.nearbreach && outboundConfig.nearbreach.hours || 0;
					this.outboundThreshold.min = outboundConfig.nearbreach && outboundConfig.nearbreach.minutes || 0;
					this.outboundTatType='cutoff';
					this.outboundTatTypeRadioButton = this.outboundTatType;
				}else{
					this.outboundFixedDuration.hrs = outboundConfig.tattime && outboundConfig.tattime.hours || 0;
					this.outboundFixedDuration.min =  outboundConfig.tattime && outboundConfig.tattime.minutes || 0;
					this.outboundFixedDurationThreshold.hrs = outboundConfig.nearbreach && outboundConfig.nearbreach.hours || 0;
					this.outboundFixedDurationThreshold.min = outboundConfig.nearbreach && outboundConfig.nearbreach.minutes || 0;
					this.outboundTatType='fixedDuration';
					this.outboundTatTypeRadioButton = this.outboundTatType;
				}
			}

		},
		async getReturnsConfigGlobal(){
			const userToken = window.localStorage.getItem('userToken');
			const myStr = userToken.replace(/"/g, '');
			const inputb2c = ({
				slalevel: 'global',
				module: 'returnb2c',
			});
			const resultb2c = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': inputb2c,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(resultb2c.status == 200 && resultb2c.data.data.length > 0){
				const returnb2cConfig = resultb2c.data.data[0];
				this.returnb2cConfigId = returnb2cConfig.id;
                if(returnb2cConfig.tattype === 'cutoff'){
					this.returnsb2cCreationCutoff.day = returnb2cConfig.tattime && returnb2cConfig.tattime.days ? returnb2cConfig.tattime.days : 1;
					this.returnsb2cCreationCutoff.hrs =  returnb2cConfig.tattime && returnb2cConfig.tattime.hours ? returnb2cConfig.tattime.hours : 0;
					if(this.returnsb2cCreationCutoff.day>7){this.returnsb2cCreationCutoff.day = 1;}
					this.returnsb2cCreationCutoff.min = returnb2cConfig.tattime && returnb2cConfig.tattime.minutes || 0;
					this.returnsb2cSla.day = returnb2cConfig.outboundsla && returnb2cConfig.outboundsla.days ? returnb2cConfig.outboundsla.days : 0;
					this.returnsb2cSla.hrs = returnb2cConfig.outboundsla && returnb2cConfig.outboundsla.hours ? returnb2cConfig.outboundsla.hours: 0;
					this.returnsb2cSla.min = returnb2cConfig.outboundsla && returnb2cConfig.outboundsla.minutes || 0;
					this.returnsb2cThreshold.hrs = returnb2cConfig.nearbreach && returnb2cConfig.nearbreach.hours || 0;
					this.returnsb2cThreshold.min = returnb2cConfig.nearbreach && returnb2cConfig.nearbreach.minutes || 0;
					this.returnsTatType='cutoff';
					this.returnsTatTypeRadioButton = this.returnsTatType;
				}else{
				this.btocReturns.hrs = returnb2cConfig.tattime.hours || 0;
				this.btocReturns.min =  returnb2cConfig.tattime.minutes || 0;
				this.btocReturnsThreshold.hrs = returnb2cConfig.nearbreach.hours || 0;
				this.btocReturnsThreshold.min = returnb2cConfig.nearbreach.minutes || 0;
				this.returnsTatType='fixedDuration';
				this.returnsTatTypeRadioButton = this.returnsTatType;
				}
			}

			const inputb2b = ({
				slalevel: 'global',
				module: 'returnb2b',
			});
			const resultb2b = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': inputb2b,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(resultb2b.status == 200 && resultb2b.data.data.length > 0){
				const returnb2bConfig = resultb2b.data.data[0];
				this.returnb2bConfigId = returnb2bConfig.id;
				if(returnb2bConfig.tattype === 'cutoff'){
					this.returnsb2bCreationCutoff.day = returnb2bConfig.tattime && returnb2bConfig.tattime.days ? returnb2bConfig.tattime.days : 1;
					this.returnsb2bCreationCutoff.hrs =  returnb2bConfig.tattime && returnb2bConfig.tattime.hours ? returnb2bConfig.tattime.hours : 0;
					if(this.returnsb2bCreationCutoff.day>7){this.returnsb2bCreationCutoff.day = 1;}
					this.returnsb2bCreationCutoff.min = returnb2bConfig.tattime && returnb2bConfig.tattime.minutes || 0;
					this.returnsb2bSla.day = returnb2bConfig.outboundsla && returnb2bConfig.outboundsla.days ? returnb2bConfig.outboundsla.days : 0;
					this.returnsb2bSla.hrs = returnb2bConfig.outboundsla && returnb2bConfig.outboundsla.hours ? returnb2bConfig.outboundsla.hours: 0;
					this.returnsb2bSla.min = returnb2bConfig.outboundsla && returnb2bConfig.outboundsla.minutes || 0;
					this.returnsb2bThreshold.hrs = returnb2bConfig.nearbreach && returnb2bConfig.nearbreach.hours || 0;
					this.returnsb2bThreshold.min = returnb2bConfig.nearbreach && returnb2bConfig.nearbreach.minutes || 0;
					this.returnsTatType='cutoff';
					this.returnsTatTypeRadioButton = this.returnsTatType;
				}else{
				this.btobReturns.hrs = returnb2bConfig.tattime.hours || 0;
				this.btobReturns.min =  returnb2bConfig.tattime.minutes || 0;
				this.btobReturnsThreshold.hrs = returnb2bConfig.nearbreach.hours || 0;
				this.btobReturnsThreshold.min = returnb2bConfig.nearbreach.minutes || 0;
				this.returnsTatType='fixedDuration';
				this.returnsTatTypeRadioButton = this.returnsTatType;
				}
			}

		},

		saveConfigInbound(){
			this.inboundTatType=this.inboundTatTypeRadioButton;
			if(this.inboundTatType=='fixedDuration'){
			let tatmins = parseInt(this.inboundtathrs*60) + parseInt(this.inboundtatmin);
			let thresholdmins = parseInt(this.inboundthresholdhrs*60) + parseInt(this.inboundthresholdmin);
			console.log("\n\nTAT", tatmins, "\n\nBREACH", thresholdmins);
			if(tatmins<=thresholdmins){
				this.inboundthresholdErr=this.$t('sla.TatMustBeGreaterThanThresholdErr');
				return false;
			}
			else{
				this.inboundthresholdErr='';
			}
			this.$validator.validateAll('tab1').then(async(result) => {
				if (result) {
					if(this.inboundthresholdmin==0 && this.inboundthresholdhrs==0){
						this.inboundthresholdErr=this.$t('sla.hrMinErr');
						}
					else{
						this.inboundthresholdErr='';
						//calling update api
						const userToken = window.localStorage.getItem('userToken');
						const myStr = userToken.replace(/"/g, '');
						const input = {
							slalevel: "global",
							module: "inbound",
							tattype: "fixed",
							tattime: `${this.inboundtathrs}:${this.inboundtatmin}`,
							nearbreach: `${this.inboundthresholdhrs}:${this.inboundthresholdmin}`,
					 	};
						const result = await axios({
							method: 'PUT',
							'url': apiUrl.api_url + 'sla-configs' + `/${this.inboundConfigId ? this.inboundConfigId : ''}`,
							'data': input,
							headers: {
								'Authorization': 'Bearer ' + myStr,
							}
						})
						if(result.status == 200 && result.data.data){
							this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
							this.drCreationCutoff.day = 1;
							this.drCreationCutoff.hrs =  null;
							this.drCreationCutoff.min = null;
							this.inboundSla.day = null;
							this.inboundSla.hrs = null;
							this.inboundSla.min = null;
							this.inboundThreshold.hrs = null;
							this.inboundThreshold.min = null;
						}else{
							this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
						}
					}
				} else {
					console.log("Invalid")
				}
			  });
			} 
			else{
				
				this.$validator.validateAll('tab5').then(async(result) => { 
					if (result) {
						let cutoffmins = parseInt(this.drCreationCutoff.day*24*60) + parseInt(this.drCreationCutoff.hrs*60) + parseInt(this.drCreationCutoff.min);
						let slamins = parseInt(this.inboundSla.day*24*60) + parseInt(this.inboundSla.hrs*60) + parseInt(this.inboundSla.min);
						let nearbreachthreshold = parseInt(this.inboundThreshold.hrs*60) + parseInt(this.inboundThreshold.min);
						console.log("\n\nCUTOFF MINS ", cutoffmins, "\n\nSLA MINS ", slamins, "\n\nTHRESHOLD ", nearbreachthreshold);
						if(this.inboundThreshold.hrs==0 && this.inboundThreshold.min==0){
							this.inboundThreshold.err=this.$t("sla.hrMinErr");
							return false;
						}
						else{
							this.inboundThreshold.err='';
						}
						if((this.inboundSla.day==0 && this.inboundSla.hrs==0 && this.inboundSla.min==0)||(this.drCreationCutoff.day==1 && this.drCreationCutoff.hrs==0 && this.drCreationCutoff.min==0)){
							this.inboundSla.err=this.$t('sla.allZeroErr');
							return false;
						}
						else if(cutoffmins && slamins && cutoffmins>=slamins){
							this.inboundSla.err = this.$t('sla.inboundSlaAndDrCreationCutoff');
							return false;
						}
						else{
							this.inboundSla.err = '';
						}
						if(nearbreachthreshold >= slamins - cutoffmins){
							this.inboundThreshold.err= this.$t('sla.NearBreachThreshErrInbound');
							return false;
						}
						else{
							this.inboundThreshold.err='';
						}
	
						// update api call
						const userToken = window.localStorage.getItem('userToken');
						const myStr = userToken.replace(/"/g, '');
						const input = {
							slalevel: "global",
							module: "inbound",
							tattype: "cutoff",
							tattime: `${this.drCreationCutoff.day} ${this.drCreationCutoff.hrs}:${this.drCreationCutoff.min}`,
							nearbreach: `${this.inboundThreshold.hrs}:${this.inboundThreshold.min}`,
							outboundsla: `${this.inboundSla.day} ${this.inboundSla.hrs}:${this.inboundSla.min}`
						};
						const result = await axios({
							method: 'PUT',
							'url': apiUrl.api_url + 'sla-configs' + `/${this.inboundConfigId ? this.inboundConfigId : ''}`,
							'data': input,
							headers: {
								'Authorization': 'Bearer ' + myStr,
							}
						})
						if(result.status == 200 && result.data.data){
							this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
							this.inboundtathrs = 0;
							this.inboundtatmin =  0;
							this.inboundthresholdhrs = 0;
							this.inboundthresholdmin = 0;

						}else{
							this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
						}
					} else {
						console.log("tab5 Invalid")
					}
				  });
				
			}
		},
		onClickMakitNull:function (selection){
			if(selection=='inboundFix' && !this.inboundtathrs)
			{
				this.inboundtathrs = '';
				this.inboundtatmin =  '';
				this.inboundthresholdhrs = '';
				this.inboundthresholdmin = '';
			}
		},
		isNumber1: function (evt) {
			var charCode = evt.which || evt.keyCode;

			if (charCode < 48 || charCode > 57) {
			  if (evt.preventDefault) {
				evt.preventDefault();
			  } else {
				if (evt.returnValue) {
				  evt.returnValue = false;
				}
			  }
			} else {
			  return true;
			}
		},
		saveConfigReturns(){
			this.returnsTatType=this.returnsTatTypeRadioButton;
			if(this.returnsTatType=='fixedDuration'){
			let b2ctatmins = parseInt(this.btocReturns.hrs*60) + parseInt(this.btocReturns.min);
			let b2cthresholdmins = parseInt(this.btocReturnsThreshold.hrs*60) + parseInt(this.btocReturnsThreshold.min);
			let b2btatmins = parseInt(this.btobReturns.hrs*60) + parseInt(this.btobReturns.min);
			let b2bthresholdmins = parseInt(this.btobReturnsThreshold.hrs*60) + parseInt(this.btobReturnsThreshold.min);
			console.log("\n\nTAT", b2ctatmins, "\n\nBREACH", b2cthresholdmins, "\n\nb2bTAT", b2btatmins, "\n\nb2bThreshold", b2bthresholdmins);

			this.$validator.validateAll('tab3').then(async(result) => {
				if (result) {
				if((this.btocReturns.hrs==0 && this.btocReturns.min==0)|| (this.btocReturnsThreshold.hrs==0 && this.btocReturnsThreshold.min==0)||(this.btobReturns.hrs==0 && this.btobReturns.min==0)||(this.btobReturnsThreshold.hrs==0 && this.btobReturnsThreshold.min==0)){
					this.btocReturns.hrminErr=this.$t('sla.hrMinErr');
                   return false;
				}
				else if(b2ctatmins<=b2cthresholdmins || b2btatmins<=b2bthresholdmins){
					this.btocReturns.hrminErr= this.$t('sla.TatMustBeGreaterThanThresholdErr');
					return false;
				}
				else{
					this.btocReturns.hrminErr='';
				}
			   console.log("valid")
				// update api call
				const userToken = window.localStorage.getItem('userToken');
				const myStr = userToken.replace(/"/g, '');
				const input = {
					slalevel: "global",
					module: "returnb2c",
					tattype: "fixed",
					tattime: `${this.btocReturns.hrs}:${this.btocReturns.min}`,
					nearbreach: `${this.btocReturnsThreshold.hrs}:${this.btocReturnsThreshold.min}`
				};
				const result = await axios({
					method: 'PUT',
					'url': apiUrl.api_url + 'sla-configs' + `/${this.returnb2cConfigId ? this.returnb2cConfigId : ''}`,
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})

				const input2 = {
					slalevel: "global",
					module: "returnb2b",
					tattype: "fixed",
					tattime: `${this.btobReturns.hrs}:${this.btobReturns.min}`,
					nearbreach: `${this.btobReturnsThreshold.hrs}:${this.btobReturnsThreshold.min}`
				};
				const result2 = await axios({
					method: 'PUT',
					'url': apiUrl.api_url + 'sla-configs' + `/${this.returnb2bConfigId ? this.returnb2bConfigId : ''}`,
					'data': input2,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})

				if(result.status == 200 && result.data.data && result2.status == 200 && result2.data.data){
					this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
					this.returnsb2cCreationCutoff.day = 1;
					this.returnsb2cCreationCutoff.hrs =  null;
					this.returnsb2cCreationCutoff.min = null;
					this.returnsb2cSla.day = null;
					this.returnsb2cSla.hrs = null;
					this.returnsb2cSla.min = null;
					this.returnsb2cThreshold.hrs = null;
					this.returnsb2cThreshold.min = null;
					this.returnsb2bCreationCutoff.day = 1;
					this.returnsb2bCreationCutoff.hrs =  null;
					this.returnsb2bCreationCutoff.min = null;
					this.returnsb2bSla.day = null;
					this.returnsb2bSla.hrs = null;
					this.returnsb2bSla.min = null;
					this.returnsb2bThreshold.hrs = null;
					this.returnsb2bThreshold.min = null;
				}else{
					this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
				}

				} else {
				console.log("Invalid")
				}
			  });
			}else{
				this.$validator.validateAll('tab6').then(async(result) => {
					if (result) {
						let returnsb2ccutoffmins = parseInt(this.returnsb2cCreationCutoff.day*24*60) + parseInt(this.returnsb2cCreationCutoff.hrs*60) + parseInt(this.returnsb2cCreationCutoff.min);
						let returnsb2cslamins = parseInt(this.returnsb2cSla.day*24*60) + parseInt(this.returnsb2cSla.hrs*60) + parseInt(this.returnsb2cSla.min);
						let nearbreachthresholdReturnsb2c = parseInt(this.returnsb2cThreshold.hrs*60) + parseInt(this.returnsb2cThreshold.min);
						console.log("\n\nCUTOFF MINS ", returnsb2ccutoffmins, "\n\nSLA MINS ", returnsb2cslamins, "\n\nTHRESHOLD ", nearbreachthresholdReturnsb2c);
						if(this.returnsb2cThreshold.hrs==0 && this.returnsb2cThreshold.min==0){
							this.returnsb2cThreshold.err=this.$t("sla.hrMinErr");
							return false;
						}
						else{
							this.returnsb2cThreshold.err='';
						}
						if((this.returnsb2cSla.day==0 && this.returnsb2cSla.hrs==0 && this.returnsb2cSla.min==0)||(this.returnsb2cCreationCutoff.day==1 && this.returnsb2cCreationCutoff.hrs==0 && this.returnsb2cCreationCutoff.min==0)){
							this.returnsb2cSla.err=this.$t('sla.allZeroErr');
							return false;
						}
						else if(returnsb2ccutoffmins && returnsb2cslamins && returnsb2ccutoffmins>=returnsb2cslamins){
							this.returnsb2cSla.err = this.$t('sla.Returnsb2cSlaAndWHInscanCreationCutoff');
							return false;
						}
						else{
							this.returnsb2cSla.err = '';
						}
						if(nearbreachthresholdReturnsb2c >= returnsb2cslamins - returnsb2ccutoffmins){
							this.returnsb2cThreshold.err= this.$t('sla.NearBreachThreshErrReturnb2c');
							return false;
						}
						else{
							this.returnsb2cThreshold.err='';
						}

						let returnsb2bcutoffmins = parseInt(this.returnsb2bCreationCutoff.day*24*60) + parseInt(this.returnsb2bCreationCutoff.hrs*60) + parseInt(this.returnsb2bCreationCutoff.min);
						let returnsb2bslamins = parseInt(this.returnsb2bSla.day*24*60) + parseInt(this.returnsb2bSla.hrs*60) + parseInt(this.returnsb2bSla.min);
						let nearbreachthresholdReturnsb2b = parseInt(this.returnsb2bThreshold.hrs*60) + parseInt(this.returnsb2bThreshold.min);
						console.log("\n\nCUTOFF MINS ", returnsb2bcutoffmins, "\n\nSLA MINS ", returnsb2bslamins, "\n\nTHRESHOLD ", nearbreachthresholdReturnsb2b);
						if(this.returnsb2bThreshold.hrs==0 && this.returnsb2bThreshold.min==0){
							this.returnsb2bThreshold.err=this.$t("sla.hrMinErr");
							return false;
						}
						else{
							this.returnsb2bThreshold.err='';
						}
						if((this.returnsb2bSla.day==0 && this.returnsb2bSla.hrs==0 && this.returnsb2bSla.min==0)||(this.returnsb2bCreationCutoff.day==1 && this.returnsb2bCreationCutoff.hrs==0 && this.returnsb2bCreationCutoff.min==0)){
							this.returnsb2bSla.err=this.$t('sla.allZeroErr');
							return false;
						}
						else if(returnsb2bcutoffmins && returnsb2bslamins && returnsb2bcutoffmins>=returnsb2bslamins){
							this.returnsb2bSla.err = this.$t('sla.Returnsb2bSlaAndWHInscanCreationCutoff');
							return false;
						}
						else{
							this.returnsb2bSla.err = '';
						}
						if(nearbreachthresholdReturnsb2b >= returnsb2bslamins - returnsb2bcutoffmins){
							this.returnsb2bThreshold.err= this.$t('sla.NearBreachThreshErrReturnb2b');
							return false;
						}
						else{
							this.returnsb2bThreshold.err='';
						}
	
	
						// update api call
						const userToken = window.localStorage.getItem('userToken');
						const myStr = userToken.replace(/"/g, '');
						const input = {
							slalevel: "global",
							module: "returnb2c",
							tattype: "cutoff",
							tattime: `${this.returnsb2cCreationCutoff.day} ${this.returnsb2cCreationCutoff.hrs}:${this.returnsb2cCreationCutoff.min}`,
							nearbreach: `${this.returnsb2cThreshold.hrs}:${this.returnsb2cThreshold.min}`,
							outboundsla: `${this.returnsb2cSla.day} ${this.returnsb2cSla.hrs}:${this.returnsb2cSla.min}`
						};
						const result = await axios({
							method: 'PUT',
							'url': apiUrl.api_url + 'sla-configs' + `/${this.returnb2cConfigId ? this.returnb2cConfigId : ''}`,
							'data': input,
							headers: {
								'Authorization': 'Bearer ' + myStr,
							}
						})

						const input2 = {
							slalevel: "global",
							module: "returnb2b",
							tattype: "cutoff",
							tattime: `${this.returnsb2bCreationCutoff.day} ${this.returnsb2bCreationCutoff.hrs}:${this.returnsb2bCreationCutoff.min}`,
							nearbreach: `${this.returnsb2bThreshold.hrs}:${this.returnsb2bThreshold.min}`,
							outboundsla: `${this.returnsb2bSla.day} ${this.returnsb2bSla.hrs}:${this.returnsb2bSla.min}`
						};
						const result2 = await axios({
							method: 'PUT',
							'url': apiUrl.api_url + 'sla-configs' + `/${this.returnb2bConfigId ? this.returnb2bConfigId : ''}`,
							'data': input2,
							headers: {
								'Authorization': 'Bearer ' + myStr,
							}
						})


						if(result.status == 200 && result.data.data && result2.status == 200 && result2.data.data){
							this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
							this.btocReturns.hrs=null
							this.btocReturns.min=null
							this.btocReturns.hrminErr=null
							this.btocReturnsThreshold.hrs=null
							this.btocReturnsThreshold.min=null
							this.btobReturns.hrs=null
							this.btobReturns.min=null
							this.btobReturnsThreshold.hrs=null
							this.btobReturnsThreshold.min=null
						}else{
							this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
						}
					} else {
						console.log("tab6 Invalid")
					}
				  });
			
			}
		},
        saveConfigOutbound(){
		this.outboundTatType=this.outboundTatTypeRadioButton;
        if(this.outboundTatType=='fixedDuration'){
			let tatmins = parseInt(this.outboundFixedDuration.hrs*60) + parseInt(this.outboundFixedDuration.min);
			let thresholdmins = parseInt(this.outboundFixedDurationThreshold.hrs*60) + parseInt(this.outboundFixedDurationThreshold.min);
			console.log("\n\nTAT", tatmins, "\n\nBREACH", thresholdmins);

			this.$validator.validateAll('tab2').then(async(result) => {
				if (result) {
					if((this.outboundFixedDuration.hrs==0 && this.outboundFixedDuration.min==0) || (this.outboundFixedDurationThreshold.hrs==0 && this.outboundFixedDurationThreshold.min==0)){
						this.outboundFixedDurationThreshold.hrMinErr=this.$t("sla.hrMinErr");
						return false;
					}
					else if(tatmins<=thresholdmins){
						this.outboundFixedDurationThreshold.hrMinErr=this.$t("sla.TatMustBeGreaterThanThresholdErr");
						return false;
					}
					else{
						this.outboundFixedDurationThreshold.hrMinErr='';

						// update api call
						const userToken = window.localStorage.getItem('userToken');
						const myStr = userToken.replace(/"/g, '');
						const input = {
							slalevel: "global",
							module: "outbound",
							tattype: "fixed",
							tattime: `${this.outboundFixedDuration.hrs}:${this.outboundFixedDuration.min}`,
							nearbreach: `${this.outboundFixedDurationThreshold.hrs}:${this.outboundFixedDurationThreshold.min}`
					 	};
						const result = await axios({
							method: 'PUT',
							'url': apiUrl.api_url + 'sla-configs' + `/${this.outboundConfigId ? this.outboundConfigId : ''}`,
							'data': input,
							headers: {
								'Authorization': 'Bearer ' + myStr,
							}
						})
						if(result.status == 200 && result.data.data){
							this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
							this.orderCreationCutoff.day = 1;
							this.orderCreationCutoff.hrs =  null;
							this.orderCreationCutoff.min = null;
							this.outboundSla.day = null;
							this.outboundSla.hrs = null;
							this.outboundSla.min = null;
							this.outboundThreshold.hrs = null;
							this.outboundThreshold.min = null;
						}else{
							this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
						}

					}
				} else {
					console.log("tab2 Invalid")
				}
			  });
		}
        else{

			this.$validator.validateAll('tab4').then(async(result) => {
				if (result) {
					let cutoffmins = parseInt(this.orderCreationCutoff.day*24*60) + parseInt(this.orderCreationCutoff.hrs*60) + parseInt(this.orderCreationCutoff.min);
					let slamins = parseInt(this.outboundSla.day*24*60) + parseInt(this.outboundSla.hrs*60) + parseInt(this.outboundSla.min);
					let nearbreachthreshold = parseInt(this.outboundThreshold.hrs*60) + parseInt(this.outboundThreshold.min);
					console.log("\n\nCUTOFF MINS ", cutoffmins, "\n\nSLA MINS ", slamins, "\n\nTHRESHOLD ", nearbreachthreshold);
			        if(this.outboundThreshold.hrs==0 && this.outboundThreshold.min==0){
						this.outboundThreshold.err=this.$t("sla.hrMinErr");;
						return false;
					}
					else{
						this.outboundThreshold.err='';
					}
					if((this.outboundSla.day==0 && this.outboundSla.hrs==0 && this.outboundSla.min==0)||(this.orderCreationCutoff.day==1 && this.orderCreationCutoff.hrs==0 && this.orderCreationCutoff.min==0)){
                        this.outboundSla.err=this.$t('sla.allZeroErr');
						return false;
					}
					else if(cutoffmins && slamins && cutoffmins>=slamins){
						this.outboundSla.err = this.$t('sla.OutboundSlaAndOrderCreationCutoff');
						return false;
					}
					else{
						this.outboundSla.err = '';
					}
					if(nearbreachthreshold >= slamins - cutoffmins){
						this.outboundThreshold.err= this.$t('sla.NearBreachThreshErr');
						return false;
					}
					else{
						this.outboundThreshold.err='';
					}

					// update api call
					const userToken = window.localStorage.getItem('userToken');
					const myStr = userToken.replace(/"/g, '');
					const input = {
						slalevel: "global",
						module: "outbound",
						tattype: "cutoff",
						tattime: `${this.orderCreationCutoff.day} ${this.orderCreationCutoff.hrs}:${this.orderCreationCutoff.min}`,
						nearbreach: `${this.outboundThreshold.hrs}:${this.outboundThreshold.min}`,
						outboundsla: `${this.outboundSla.day} ${this.outboundSla.hrs}:${this.outboundSla.min}`
					};
					const result = await axios({
						method: 'PUT',
						'url': apiUrl.api_url + 'sla-configs' + `/${this.outboundConfigId ? this.outboundConfigId : ''}`,
						'data': input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					if(result.status == 200 && result.data.data){
						this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
						this.outboundFixedDuration.hrs = null;
						this.outboundFixedDuration.min =  null;
						this.outboundFixedDurationThreshold.hrs = null;
						this.outboundFixedDurationThreshold.min = null;
					}else{
						this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
					}
				} else {
					console.log("tab4 Invalid")
				}
			  });
		}
		},
		async resetConfigInbound(){
			await this.getInboundConfigGlobal()
			this.inboundtathrs=''
			this.inboundtatmin=''
			this.inboundthresholdhrs=''
			this.inboundthresholdmin=''
			this.inboundthresholdErr=''
			this.inboundSla.day=''
			this.inboundSla.hrs=''
			this.inboundSla.min=''
			this.inboundSla.err='',
			this.inboundThreshold.hrs=''
			this.inboundThreshold.min=''
			this.inboundThreshold.err=''
			// this.inboundTatType='fixedDuration'
			// this.inboundTatTypeRadioButton= 'fixedDuration'
			this.drCreationCutoff.day=1
			this.drCreationCutoff.min=''
			this.drCreationCutoff.hrs=''
		},
		async resetConfigOutbound(){
			await this.getOutboundConfigGlobal()
			this.outboundFixedDuration.hrs=''
			this.outboundFixedDuration.min=''
			this.outboundFixedDurationThreshold.hrs=''
			this.outboundFixedDurationThreshold.min=''
			this.outboundFixedDurationThreshold.hrMinErr=''
			this.outboundSla.day=''
			this.outboundSla.hrs=''
			this.outboundSla.min=''
			this.outboundSla.err=''
			this.outboundThreshold.hrs=''
			this.outboundThreshold.min=''
			this.outboundThreshold.err=''
			// this.outboundTatType='fixedDuration'
			// this.outboundTatTypeRadioButton= 'fixedDuration'
			this.orderCreationCutoff.day=1
			this.orderCreationCutoff.min=''
			this.orderCreationCutoff.hrs=''
		},
		async resetConfigReturns(){
			await this.getReturnsConfigGlobal()
			this.btocReturns.hrs=''
			this.btocReturns.min=''
			this.btocReturns.hrminErr=''
			this.btocReturnsThreshold.hrs=''
			this.btocReturnsThreshold.min=''
			this.btobReturns.hrs=''
			this.btobReturns.min=''
			this.btobReturnsThreshold.hrs=''
			this.btobReturnsThreshold.min=''
			this.returnsb2cCreationCutoff.day = 1;
		    this.returnsb2cCreationCutoff.hrs = '';
			this.returnsb2cCreationCutoff.min = '';
			this.returnsb2cSla.day = '';
			this.returnsb2cSla.hrs = '';
			this.returnsb2cSla.min = '';
			this.returnsb2cThreshold.hrs = '';
			this.returnsb2cThreshold.min = '';
			this.returnsb2bCreationCutoff.day = 1;
			this.returnsb2bCreationCutoff.hrs =  '';
			this.returnsb2bCreationCutoff.min = '';
			this.returnsb2bSla.day = '';
			this.returnsb2bSla.hrs = '';
			this.returnsb2bSla.min = '';
			this.returnsb2bThreshold.hrs = '';
			this.returnsb2bThreshold.min = '';
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/SLA/slaglobal/slaglobal.component.js